module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital01-0c529a60d4be75d0970179d6a04179fa.png";